/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'commerce-subscription-auto-upgrade-no-payment-method-ccp': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--commerce-subscription-auto-upgrade-no-payment-method-ccp/placements/in-app/screen-space-flags/render'
			),
	),
};
